import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LlmConfig {
  provider: 'ollama' | 'deepseek';
  model: string;
  availableModels: string[];
}

interface ModelState {
  model: string;
  provider: 'ollama' | 'deepseek';
  availableModels: string[];
  setModel: (model: string) => void;
  setConfig: (config: LlmConfig) => void;
}

export const useModelStore = create<ModelState>()(
  persist(
    (set) => ({
      model: 'qwen2.5:7b',
      provider: 'ollama',
      availableModels: ['qwen2.5:7b', 'qwen2.5:14b'],
      setModel: (model) => set({ model }),
      setConfig: (config) =>
        set((state) => {
          const isCurrentAvailable = config.availableModels.includes(state.model);
          return {
            provider: config.provider,
            availableModels: config.availableModels,
            model: isCurrentAvailable ? state.model : config.model,
          };
        }),
    }),
    {
      name: 'mixly-model',
    },
  ),
);
